import React from 'react';
import SectionWrapper from './SectionWrapper';

const ProcessList = ({ 
  section, 
  className = '',
  wrapperClassName = 'introduction',
  showContent = false
}) => {
  if (!section) return null;

  return (
    <SectionWrapper className={wrapperClassName}>
      <div className={className}>
        <h4>{section.title}</h4>
        {showContent && section.content && (
          <span>{section.content}</span>
        )}
        {section.items && (
          <ul>
            {section.items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        )}
        {section.lists && section.lists.map((list, listIndex) => (
          <div key={listIndex}>
            {list.subtitle && <span>{list.subtitle}</span>}
            <ul>
              {list.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
};

export default ProcessList;